import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { finalizarComanda, revertirComanda } from '../../../actions/comandas';

const StatusComanda = ({ comanda, reestablecerComanda }) => {

    const dispatch =  useDispatch();

    const [statusModal, setStatusModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Status comanda */
    const handleFinalizar = async () => {
        await setStatusProcesar(true);
        await dispatch(finalizarComanda(comanda));
        await handleCerrar(null);
        await setStatusProcesar(false);
    }

    const handleRevertir = async () => {
        await setStatusProcesar(true);
        await dispatch(revertirComanda(comanda));
        await handleCerrar(null);
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerComanda(null);
            setStatusModal(false);
        }
    }

    useEffect(() => {
        if(comanda != null){
            setStatusModal(true);
        }
    }, [comanda]);

    return (
        <Modal show={statusModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Status de la comanda</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Qué deseas hacer con la comanda para "{comanda?.evento?.tipo_evento?.nombre + ' (' + comanda?.evento?.paciente?.nombre + ' - ' + comanda?.evento?.espacio?.nombre + ')" del ' + new Date(comanda?.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' ' + new Date(comanda?.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' })}?</p>
            </Modal.Body>
            <Modal.Footer>
                {
                    comanda?.status == 1 &&
                        (
                            statusProcesar ? (
                                <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Finalizarla</button>
                            ) : (
                                <button type="button" className="btn btn-success" onClick={() => handleFinalizar()}><i className="fas fa-check"></i> Finalizarla</button>
                            )
                        )
                }
                {
                    comanda?.status == 2 &&
                        (
                            statusProcesar ? (
                                <button type="button" className="btn btn-warning" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Revertirla</button>
                            ) : (
                                <button type="button" className="btn btn-warning" onClick={() => handleRevertir()}><i className="fas fa-rotate-left"></i> Revertirla</button>
                            )
                        )
                }
            </Modal.Footer>
        </Modal>
    )
}

export default StatusComanda;
